import request from "../utils/request";

export const list = (data) => request.get("/api/quick-message", data);
export const create = (data) => request.post("/api/quick-message", data);
export const toggle = (id) => request.put(`/api/quick-message/${id}/toggle`);
export const remove = (id) => request.put(`/api/quick-message/${id}/remove`);
export const update = (id, data) => request.put(`/api/quick-message/${id}`, data);